module.exports = __webpack_public_path__ + "img/scribd.png";